import { render, staticRenderFns } from "./CollectionsConditionsCatalogueData.vue?vue&type=template&id=24f545a3&scoped=true"
import script from "./CollectionsConditionsCatalogueData.vue?vue&type=script&lang=js"
export * from "./CollectionsConditionsCatalogueData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f545a3",
  null
  
)

export default component.exports